import styled from 'styled-components'

interface ContainerProps {
  backgroundColor: string
}

export const Container = styled.div<ContainerProps>`
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  height: 30px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 4px;
  margin-right: 16px;
  background-color: ${(p) => p.backgroundColor};
  color: ${(p) => p.theme.colors.white};
  white-space: nowrap;

  &:hover {
    background-color: ${(p) => p.backgroundColor};
  }
`
